import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import ProtectedRoute from '../containers/Session/ProtectedRoute';
import SignIn from '../containers/SignIn';
import Dashboard from '../pages/Dashboard';
import Charts from '../containers/Charts';
import SalesFrequency from '../containers/SalesFrequency';
import SalesFrequencyAtual from '../containers/SalesFrequencyAtual';
import Customers from '../containers/Customers';
import Wallet from '../containers/Wallet';
import Billed from '../containers/Billed';
import Duplicates from '../containers/Duplicates';
import CanceledOrders from '../containers/CanceledOrders';
import CustomerPerformance from '../containers/CustomerPerformance';
import Routes from '../containers/Routes';

const Router = (props) => (
	<Switch>
		<Route path="/signIn" component={SignIn} />
		<ProtectedRoute name="Dashboard" path="/dashboard" component={Dashboard} />
		<ProtectedRoute name="Indicadores" path="/charts" component={Charts} />
		<ProtectedRoute
			name="Potencial Novo"
			path="/salesFrequency"
			component={SalesFrequency}
		/>
		<ProtectedRoute
			name="Potencial"
			path="/salesFrequencyAtual"
			component={SalesFrequencyAtual}
		/>
		<ProtectedRoute name="Clientes" path="/customers" component={Customers} />
		<ProtectedRoute name="Carteira" path="/wallet" component={Wallet} />
		<ProtectedRoute name="Faturado" path="/billed" component={Billed} />
		<ProtectedRoute
			name="Dup. Aberto"
			path="/duplicates"
			component={Duplicates}
		/>
		<ProtectedRoute
			name="Ped. Cancelados"
			path="/canceledOrders"
			component={CanceledOrders}
		/>
		<ProtectedRoute
			name="Desemp. Clientes"
			path="/customerPerformance"
			component={CustomerPerformance}
		/>
		<ProtectedRoute name="Rotas" path="/routes" component={Routes} />
		<Redirect exact path="/" to="/dashboard" />
	</Switch>
);

export default Router;
